import { Col, Row } from 'antd'
import { Card, Icon, LoadingSpinner, Modal, Tooltip, ButtonGroup, Toggle } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import './Modal.scss'
import ModalFilters from './ModalFilters'
import SingleBarChart from '../Charts/SpendAnalyticsChart/SingleBarChart'
import { spendDetailViewDataMock, spendByBottomSupplier } from "../../mocks/SpendChartData"
import StackedBarChart from '../Charts/SpendAnalyticsChart/StackedBarChart'
import { formatNumberWithCommas, splitNumericValue, splitValueWithUnit, returnHyphenIfNull } from '../../utils/utils'
import Legend from '../Charts/Legend/Legend'
import NoData from '../NoData/NoData'
import PieChartWithTicks from '../Charts/PieChart/PieChartWithTicks'
import { localStoreKeys } from '../../constants/localStoreKeys'
import { useSelector } from "react-redux";
import { appConstants } from '../../constants/appconstants'
import SpendDonutChart from '../Charts/SpendAnalyticsChart/SpendDonutChart'
import LegendList from '../Charts/Legend/LegendList'
import SpendStackedBarChart from '../Charts/SpendAnalyticsChart/SpendStackedBarChart'
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons'
import DropdownWithIcons from './DropdownWithIcons'
import { ToastContainer, toast, Slide } from "react-toastify";
import { useToast } from '../../components/Toast/ToastContext';
import { staticNotes } from '../../constants/staticNotes';
// import { useToast } from '../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import domtoimage from "dom-to-image";
import domtoimagejpeg from 'dom-to-image-more';
import jsPDF from "jspdf";
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { spendResilincDropdownoptions, generatePdfFromNode, generateJpegFromNode, buildFileName, svgDropdownIcon } from '../../utils/utils' 

function KpiModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    const [spendDetailViewData, setSpendDetailViewData] = useState({})
    const [showPieChart, setShowPieChart] = useState(false)
    const [loader, setLoader] = useState(true)
    const [dataIssueWarningText, setDataIssueWarningText] = useState("");
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [monthDiff, setMonthDiff] = useState(0)
    const [showButtonDropdown, setShowButtonDropdown] = useState(false)
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const [dataLoadActionType, setDataLoadActionType] = useState("");  
    const [l0InnerDonutFlag, setL0InnerDonutFlag] = useState(true);
    const [displayDate, setDisplayDate] = useState(false)

    const [isDownloadSingleBarChart, setIsDownloadSingleBarChart] = useState(false);
    const [isSpendPdfDownloaded, setIsSpendPdfDownloaded] = useState(false);
    const [isJpegDownloaded, setIsJpegDownloaded] = useState(false);
    const [currentStateRef, setCurrentStateRef] = useState(false);
    const [currentKPIName, setCurrentKPIName] = useState('');
    
    const [showInprogressModal, setShowInprogressModal] = useState(false)
    const [negativeSpendGraphTab, setNegativeSpendGraphTab] = useState(false);
    const { showToast } = useToast();

    const MODAL_TITLE = 'Spend Analytics';

    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        // Clear data load action type
        setDataLoadActionType("");
        // Close the modal
        setOpenModal(false);
    };
    
    function formatSingleBarChartData(map) {
        if (map !== null && map !== undefined) {
            return Object.entries(map)
                .map(([name, value]) => {
                    const unit = splitNumericValue(value)?.['suffix']
                    const numericValue = parseFloat(value?.split(" ")[0]) * 1;
                    return {
                        name: name,
                        value: value,
                        numericValue: numericValue,
                        unit: unit
                    };
                })
                ?.sort((a, b) => b.numericValue - a.numericValue);
        }
        return []
    }

    
    function formatTailBottomSupplierData(input) {
        return input !== null && input !== undefined ? input?.map(item => {
            const valueWithoutUnit = splitNumericValue(item.supplierSpend)?.['value']
            const unit = splitNumericValue(item.supplierSpend)?.['suffix']
            const numericValue = parseFloat(item.supplierSpend.replace(unit, ""));
            return {
                name: item.supplierName,
                value: item.supplierSpend,
                numericValue: numericValue,
                unit: unit
            };
        })?.sort((a, b) => b.numericValue - a.numericValue) : []
    }

    
    const getSpendDataFromFilters = (value) => {
        // console.log("spend value", value);
        setLoader(value.loader);
        setDisplayDate(value?.spendData?.lastUpdate)
        setMonthDiff(value.monthDiff)
        setSpendDetailViewData(value?.spendData)
        setDataLoadActionType(value?.spendData?.type)
        setNegativeSpendGraphTab(false)
        if (value?.BU?.length === 1 && value?.categoriesLevel1?.length === 1) {
            setShowPieChart(true)
        } else {
            setShowPieChart(false)
        }
        if(value?.categoriesLevel0?.length <= 1) {
            setL0InnerDonutFlag(false)
        } else {
            setL0InnerDonutFlag(true)
        }

        const appList = value?.spendData?.apps?.filter(item => item.isActive)
        // console.log(appList)
        if (appList && appList.length > 0) {

            if (appList.length > 1) {
                setShowButtonDropdown(true)
                const tempbuttonGroupItems = [
                    { icon: "link", label: "Link to Apps", onClick: () => console.log("clicked") },
                    ...appList
                        ?.filter(item => item.isActive)
                        .map((item) => ({
                            label: item.app,
                            onClick: () => { window.open(item.url, "_blank") },
                        })),
                ];
                setButtonGroupItems(tempbuttonGroupItems)
            } else {
                setShowButtonDropdown(false)
                const tempbuttonGroupItems = appList
                    ?.filter(item => item.isActive)
                    .map(item => ({
                        label: item.app,
                        onClick: () => window.open(item.url, "_blank"),
                    }));

                //  console.log(tempbuttonGroupItems)
                setButtonGroupItems(tempbuttonGroupItems)
            }
        }
        else {
            setButtonGroupItems([]);
        }
        // console.log(buttonGroupItems)

    }

    const spendAnalyticsRef = useRef()
    const SpendSplitbyDirectRef = useRef()
    const SpendbyBUtMarketRef = useRef()
    const SpendUnderReconciliationRef = useRef()
    const SpendbySubCategoryRef = useRef()
    const SpendbyTop10SuppliersRef = useRef()
    const TailSpendRef = useRef()
    const dropdownRef = useRef(null);
    const dropdownsingleBarRef = useRef(null);
    const dropdownspendTop10Ref = useRef(null);


    const [open, setOpen] = useState(false);
    const [singleBarOptionopen, setSingleBarOptionopen] = useState(false);
    const [spendTop10Optionopen, setSpendTop10Optionopen] = useState(false);
  
    const toggleDropdown = () => {
        setOpen(!open);
    }

    const toggleSingleBarOptionDropdown = () => {
        setSingleBarOptionopen(!singleBarOptionopen);
    }

    const toggleSpendTop10OptioDropdown = () => {
        setSpendTop10Optionopen(!spendTop10Optionopen);
    }

    const [initialTailSpendRefSnapshot, setInitialTailSpendRefSnapshot] = useState(null);
    const [initialSpendbyTop10SuppliersRefSnapshot, setInitialSpendbyTop10SuppliersRefSnapshot] = useState(null);
    const [initialSpendModalSnapshot, setInitialSpendModalSnapshot] = useState(null);
     


    const spendByTopSupplier = formatSingleBarChartData(spendDetailViewData?.topTenSupplierDTO?.map);
    const overAllSpend = spendDetailViewData?.kpiDetailsForSpendDataFromRangeWithStringValue?.overAllSpend
    const totalSpendValue = splitValueWithUnit(overAllSpend)?.['numericValue']
    const totalSpendUnit = splitValueWithUnit(overAllSpend)?.['unit']
    const totalBottomSuppliers = formatTailBottomSupplierData(spendDetailViewData?.kpiDetailsForSpendDataForTailSpend?.map)
    const percentOfLastYearData = spendDetailViewData?.kpiDetailsForSpendDataFromRangeWithStringValue?.percentOfLastYearData
    const lastYearSpendData = spendDetailViewData?.kpiDetailsForSpendDataFromRangeWithStringValue?.lastYearSpendData
    const managedSpend = spendDetailViewData?.kpiDetailsForSpendDataFromRangeWithStringValue?.managedSpend
    const averageSupplierSpend = spendDetailViewData?.kpiDetailsForSpendDataFromRangeWithStringValue?.averageSupplierSpend
    const totalSupplierCount = spendDetailViewData?.kpiDetailsForSpendDataFromRangeWithStringValue?.totalSupplierCount
    const totalPoCount = spendDetailViewData?.kpiDetailsForSpendDataFromRangeWithStringValue?.totalPoCount
    const lastUpdate = (spendDetailViewData?.lastUpdate)
    const refreshFrequency = (spendDetailViewData?.refreshFrequency)

    const sectorSelected = useSelector((state) => state?.localData?.data[localStoreKeys.sectorSelectedOnDetail]);
    const appOwnersList = spendDetailViewData?.owners
    const emailList = appOwnersList?.map(contact => contact.emailId).join(', ');

    const sectorCategoryStudyCount = spendDetailViewData?.kpiDetailsCategoryDTOV2List
    const sectorBuStudyCount = spendDetailViewData?.kpiDetailsBuDTOV2List
    const sectorBuColor = spendDetailViewData?.sectorBuColor
    const sectorCategoryColor = spendDetailViewData?.sectorCategoryColor
    const sectorNegativeBuColor = spendDetailViewData?.negativeSectorBuColor
    const sectorNegativeCategoryColor = spendDetailViewData?.negativeSectorL0Color
    
    const sectorL0Spend = spendDetailViewData?.sectorVsCategoryL0SpendDetails
    const tempSectorL0Color = spendDetailViewData?.sectorL0CategoryColor
    const buReconSpend = spendDetailViewData?.negativeBuSpend || "1" // "-$21MN"
    const l0ReconSpend = spendDetailViewData?.negativeL0Spend || "1" // "-$11MN"
    
    const showNote = spendDetailViewData?.showNote
    const isEDFIntegrated = spendDetailViewData?.edfintegrated;
    // const sectorL0Color = Array.from(
    //     new Map(tempSectorL0Color.map(obj => [obj.name, obj])).values()
    //   );
    
    const sectorL0Color = Array.isArray(tempSectorL0Color)
        ? Array.from(new Map(tempSectorL0Color.map(obj => [obj.name, obj])).values())
    : [];

    
    let transformedBUData = sectorBuStudyCount?.map(item => ({
        category: item.sector,
        name: item.bu,
        color: item.colorCode?item.colorCode:"#000000",
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        value: Number(item.spend)
      })); 
    const uniqueSectorValuesForBUChart = new Set(transformedBUData?.map(item => item.category));
    const multipleSectorFlagForBUChart = uniqueSectorValuesForBUChart?.size > 1;
    // console.log(transformedBUData)
    // const negativeBUSum = transformedBUData?.filter(item => item.value < 0)
    //                                         .reduce((sum, item) => sum + item.value, 0);
    // transformedBUData = transformedBUData?.filter(item => item.value >= 0);
    // console.log(negativeBUSum) 


    
    let transformedL0Data = sectorL0Spend?.map(item => ({
        category: item.sector,
        name: item.category,
        color: item.colorCode?item.colorCode:"#000000",
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        value: Number(item.spend)
      }));
    const uniqueSectorValuesForL0Chart = new Set(transformedL0Data?.map(item => item.category));
    const multipleSectorFlagForL0Chart = uniqueSectorValuesForL0Chart?.size > 1;
    // const negativeL0Sum = transformedL0Data?.filter(item => item.value < 0)
    //                                         .reduce((sum, item) => sum + item.value, 0);
    // transformedL0Data = transformedL0Data?.filter(item => item.value >= 0);
    // console.log(negativeL0Sum)

    
    const transformedCategoryData = sectorCategoryStudyCount?.map(item => ({
        category: item.sector,
        name: item.category,
        color: item.colorCode?item.colorCode:"#000000",
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        value: Number(item.spend)
      }));
    const uniqueSectorValuesForCategoryChart = new Set(transformedCategoryData?.map(item => item.category));
    const multipleSectorFlagForCategoryChart = uniqueSectorValuesForCategoryChart?.size > 1;

    const dataMap = {};
    const categoryColor = [];

    
    transformedCategoryData?.forEach(item => {
        const { category, name, color, value } = item;

        if (!dataMap[category]) {
            dataMap[category] = { category };
        }
        dataMap[category][name] = value;

        categoryColor.push({ category, name, color });
    });

    const categoryStackData = Object.values(dataMap);


    const dataL0Map = {};
    const categoryL0Color = [];

    
    transformedL0Data?.forEach(item => {
        const { category, name, color, value } = item;

        if (!dataL0Map[category]) {
            dataL0Map[category] = { category };
        }
        dataL0Map[category][name] = value;

        categoryL0Color.push({ category, name, color });
    });

    const categoryL0StackData = Object.values(dataL0Map);


    
    const dataBUMap = {};
    const categoryBUColor = [];

    
    transformedBUData?.forEach(item => {
        const { category, name, color, value } = item;

        if (!dataBUMap[category]) {
            dataBUMap[category] = { category };
        }
        dataBUMap[category][name] = value;

        categoryBUColor.push({ category, name, color });
    });

    const categoryBUStackData = Object.values(dataBUMap);


    const negativeSectorL0StudyCount = spendDetailViewData?.negativeSpendBySectorL0
    const negativeTransformedL0Data = negativeSectorL0StudyCount?.map(item => ({
        category: item.sector,
        name: item.category,
        color: item.colorCode?item.colorCode:"#000000",
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        value: Number(item.spend)
      }));
    const dataNegativeL0Map = {};
    const negativeL0Color = [];
    
    negativeTransformedL0Data?.forEach(item => {
        const { category, name, color, value } = item;

        if (!dataNegativeL0Map[category]) {
            dataNegativeL0Map[category] = { category };
        }
        dataNegativeL0Map[category][name] = value;

        negativeL0Color.push({ category, name, color });
    });
    
    const negativeL0StackData = Object.values(dataNegativeL0Map);


    const negativeSectorBUStudyCount = spendDetailViewData?.negativeSpendBySectorBu
    const negativeTransformedBUData = negativeSectorBUStudyCount?.map(item => ({
        category: item.sector,
        name: item.bu,
        color: item.colorCode?item.colorCode:"#000000",
        sectorColor: item.sectorColorCode?item.sectorColorCode:"#000000",
        value: Number(item.spend)
      }));
    const dataNegativeBUMap = {};
    const negativeBUColor = [];
    
    negativeTransformedBUData?.forEach(item => {
        const { category, name, color, value } = item;

        if (!dataNegativeBUMap[category]) {
            dataNegativeBUMap[category] = { category };
        }
        dataNegativeBUMap[category][name] = value;

        negativeBUColor.push({ category, name, color });
    });
    
    const negativeBUStackData = Object.values(dataNegativeBUMap);


    console.log("spendCategoryColor", categoryColor)
    
    useEffect(() => {
        if (sectorSelected && sectorSelected.length > 0) {
            const hasNonAMESA = sectorSelected.some(item => item.displayText !== "AMESA");
            const hasAMESA = sectorSelected.some(item => item.displayText === "AMESA");
            let appName = "Spend HQ"
            // if (hasAMESA) {
            //     if (hasNonAMESA) {
            //        // appName = "Spend HQ/AMESA PBI App"
            //     } else {
            //        // appName = "AMESA PBI App"
            //     }
            // }
            setDataIssueWarningText("Due to some updates in " + appName + ", numbers what you see here can differ slightly. This is expected to solve soon by app team");

        }
    }, [sectorSelected])

    const opts = [
        {
          id: 1,
          label: "Today",
          icon: (
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 6 }}
            >
              <circle cx="12" cy="12" r="10" fill="lightgray" stroke="black" />
              <path d="M12 6v6l3 2" stroke="black" strokeWidth="2" fill="none" />
            </svg>
          ),
        },
        {
          id: 2,
          label: "This Week",
          icon: (
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 6 }}
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="16"
                fill="lightgray"
                stroke="black"
              />
              <line x1="3" y1="10" x2="21" y2="10" stroke="black" strokeWidth="2" />
            </svg>
          ),
        },
        {
          id: 3,
          label: "This Month",
          icon: (
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 6 }}
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="16"
                fill="lightgray"
                stroke="black"
              />
            </svg>
          ),
        },
      ];

    //   const handleDomToImgDownloadPdf = async (ref, kpiName) => {
    //     const node = ref.current
    //      try {
    //      const dataUrl = await domtoimage.toPng(node, {
    //          quality: 1,
    //          cacheBust: true,
    //      });
    
    //      const pdf = new jsPDF({
    //          orientation: "portrait",
    //          unit: "mm",
    //          format: "a4", // A2 paper size
    //      });
    
    //      const img = new Image();
    //      img.src = dataUrl;
    
    //      img.onload = () => {
    //                  const imgProps = pdf.getImageProperties(dataUrl);
    //                  const pageWidth = pdf.internal.pageSize.getWidth();
    //                  const pageHeight = pdf.internal.pageSize.getHeight();
    
    //                  let pdfWidth = pageWidth;
    //                  let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    
    //                  // Resize if image is too tall
    //                  if (pdfHeight > pageHeight) {
    //                  pdfHeight = pageHeight;
    //                  pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
    //                  }
    
    //                  const x = (pageWidth - pdfWidth) / 2;
    //                  const y = (pageHeight - pdfHeight) / 2;
    
    //                  pdf.addImage(dataUrl, 'PNG', x, y, pdfWidth, pdfHeight);
                     
    
    //                  // Build dynamic filename in "refVal_YYYYMMDD" format
    //                 const today = new Date();
    //                 const yyyy = today.getFullYear();
    //                 const mm = String(today.getMonth() + 1).padStart(2, "0");
    //                 const dd = String(today.getDate()).padStart(2, "0");
    //                 const formattedDate = `${yyyy}${mm}${dd}`;
    
    //                 const fileName = `${kpiName}_${formattedDate}.pdf`;
    
    //                 pdf.save(fileName);
    
                    
    
    //              };
    //              } catch (error) {
    //              console.error("Failed to generate PDF:", error);
    //      }
    // };
      
	
      function handleSelect(option) {
        console.log("selected", option);
        // your logic here
      }

	
      const checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
        if(isPdfDownloaded){
            if(isModal){
                showToast('success', !isJpeg ? "PDF of full page successfully downloaded." : 'JPEG of full page successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            } else if(isTable){
                showToast('success', !isJpeg ? "PDF of a table successfully downloaded." : 'JPEG of a table successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
            else{
                showToast('success', !isJpeg ? "PDF of a chart successfully downloaded.": 'JPEG of a chart successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
           

        }
        else{
            showToast('Error', "Failed to download. Please try again.", {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        }   
      }

	
      useEffect(()=>{
        setIsDownloadSingleBarChart(false)
    }, [isSpendPdfDownloaded])

	
    useEffect(()=>{
        setShowInprogressModal(true)
        const downloadSpendPdf = async(opts=[]) => {

            
        try {

            await generatePdfFromNode({
                node: currentStateRef.current,
                currentKPIName,
                opts,
              });

            setIsSpendPdfDownloaded(true)
            //   setIsJpegDownloaded(false)
            setShowInprogressModal(false)
            checkPDFDownloaded(true, currentKPIName == 'Spend_Analytics_Modal' ? true : false, "", false, false, false)
        } catch (err) {
            setIsSpendPdfDownloaded(true)
            // setIsJpegDownloaded(false)
            setShowInprogressModal(false)
            console.error("Failed to generate PDF:", err);
            checkPDFDownloaded(false, currentKPIName == 'Spend_Analytics_Modal' ? true : false, "", false, false, false)
        }
        }

        const downloadSpendJpeg = async(opts=[]) => {
        
        try{

            const fileName = buildFileName(currentKPIName, "jpeg");

            await generateJpegFromNode({
            node: currentStateRef.current,
            fileName,
            ...opts,
            });

                setIsSpendPdfDownloaded(true)
                // setIsJpegDownloaded(true)
                setShowInprogressModal(false)
                checkPDFDownloaded(true, currentKPIName == 'Spend_Analytics_Modal' ? true : false, "", false, false, true)
        }
        catch(error) {
                setIsSpendPdfDownloaded(true)
                // setIsJpegDownloaded(true)
                setShowInprogressModal(false)
                console.error('Error exporting chart as JPEG', error);
                checkPDFDownloaded(false, currentKPIName == 'Spend_Analytics_Modal' ? true : false, "", false, false, false)
        };

            return
        }
        
        if(isDownloadSingleBarChart){
            setTimeout(() => {
                if(isJpegDownloaded){
                    downloadSpendJpeg()
                } else{
                    downloadSpendPdf()
                }
                
                
            }, [2000]);
            
        }
        else{
            setIsSpendPdfDownloaded(false)
            setIsJpegDownloaded(false)
            setShowInprogressModal(false)
            return
        }
         
    }, [isDownloadSingleBarChart])

      // close dropdown when clicked outside
	
    useEffect(() => {
        const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }
        if (dropdownsingleBarRef.current && !dropdownsingleBarRef.current.contains(e.target)) {
            setSingleBarOptionopen(false)
        }
        if (dropdownspendTop10Ref.current && !dropdownspendTop10Ref.current.contains(e.target)) {
            setSpendTop10Optionopen(false)
        }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const options = [
        {
          label: "Download as PDF",
          icon: (
            <svg width="14" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_400_531382)">
                <path d="M3.225 0C2.345 0 1.633 0.72 1.633 1.6L1.625 14.4C1.625 15.28 2.337 16 3.217 16H12.825C13.705 16 14.425 15.28 14.425 14.4V4.8L9.625 0H3.225ZM8.825 5.6V1.2L13.225 5.6H8.825Z" fill="#8D466D"/>
              </g>
              <defs>
                <clipPath id="clip0_400_531382">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          ),
        },
        {
            label: "Download as JPEG",
            icon: (
              <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.225 0C1.345 0 0.633 0.72 0.633 1.6L0.625 14.4C0.625 15.28 1.337 16 2.217 16H11.825C12.705 16 13.425 15.28 13.425 14.4V4.8L8.625 0H2.225ZM7.825 5.6V1.2L12.225 5.6H7.825Z" fill="#8458CC"/>
              </svg>
    
            ),
          },
        // ...(isTable
        //   ? [
        //       {
        //         label: "Download as XLS",
        //         icon: (
        //           <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //           <path d="M2.225 0C1.345 0 0.633 0.72 0.633 1.6L0.625 14.4C0.625 15.28 1.337 16 2.217 16H11.825C12.705 16 13.425 15.28 13.425 14.4V4.8L8.625 0H2.225ZM7.825 5.6V1.2L12.225 5.6H7.825Z" fill="#008553"/>
        //           </svg>
    
        //         ),
        //       },
        //     ]
        //   : []),
      ];



	
    const svgDropdownIconSingleBarChart = (isModal, refName, kpiName, isTable) => {
        return(
        <>
            <div ref={kpiName == 'Spend by Top 10 Suppliers (in USD Million)' ? dropdownspendTop10Ref : dropdownsingleBarRef}
             style={{ position: "relative", display: "inline-block", background: 'white', 
                      height: '30px', borderRadius: '5px', border: '1px solid #d3caca'}}>
            {/* Trigger Button */}
            <div style={{display: 'flex'}}>
            <Tooltip text={isModal ? 'Download Full Page' : isTable ? 'Download this table' : 'Download this chart'} direction={isModal ? "left": "top-middle"} style={{display: 'flex !important', zIndex: '999999'}}>
                <button
                onClick={kpiName == 'Spend by Top 10 Suppliers (in USD Million)' ? toggleSpendTop10OptioDropdown : toggleSingleBarOptionDropdown}
                style={{
                    background: "white",
                    border: "none",
                    cursor: "pointer",
                    display: 'flex',
                    position: 'relative',
                    top: '0.35rem'
                }}
                >
                <Icon
                    alt="alt value"
                    icon={"download"}
                    size="small"
                    style={{ color: '#005cbc' }}
                />
                <Icon
                    alt="alt value"
                    icon={"arrow_drop_down"}
                    size="small"
                    style={{ color: '#005cbc' }}
                />
                {/* <img src={DownloadFileFormat} alt="download" /> */}
                </button>
            </Tooltip>
            </div>
    
            {/* Dropdown Menu */}
            { (kpiName == 'Spend by Top 10 Suppliers (in USD Million)' ? spendTop10Optionopen : singleBarOptionopen) && (
                <ul
                style={{
                    position: "absolute",
                    // top: "120%",
                    right: 0,
                    background: "white",
                    listStyle: "none",
                    padding: "4px 0",
                    margin: 0,
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    minWidth: "150px",
                    fontSize: "12px",
                    zIndex: '99999'
                }}
                >
                {spendResilincDropdownoptions.map((opt, idx) => (
                    <li
                    key={idx}
                    role="button" 
                    tabIndex={0}
                    style={{
                        padding: "0 5px",
                        display: "flex",
                        alignItems: "center",
                        height: '1.5rem',
                        cursor: "pointer",
                    }}
                    // onClick={() => {
                    //     handleDomToImgDownloadPdf(modalRef, kpiName, opt.label)
                    //     setOpen(false);
                    // }}
                    onClick={() => {
                        setIsDownloadSingleBarChart(true);
                        setIsJpegDownloaded(opt.label == "Download as JPEG" ? true : false)
                        setCurrentStateRef(refName);
                        setCurrentKPIName(kpiName)
                        kpiName == 'Spend by Top 10 Suppliers (in USD Million)' ? setSpendTop10Optionopen(false) : setSingleBarOptionopen(false);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          e.currentTarget.click();
                        }
                    }}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f5f5f5")
                    }
                    onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                    }
                    >
                    {opt.icon}
                    <span style={{ marginLeft: "6px", fontWeight: '500' }}>{opt.label}</span>
                    </li>
                ))}
                </ul>
            )}
            </div>
        </>
        )
    }
    
    
    return (
        <Modal
           // onCloseModal={() => { setDataLoadActionType(""); setOpenModal(!openModal); }}
            onCloseModal={handleClose}
            primaryButtonProps={{
                //onClick: () => { setDataLoadActionType(""); setOpenModal(!openModal) },
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            {/* <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        toastClassName="custom-toast"
                        bodyClassName="custom-toast-body"
                        // style={{
                        //   right: isOpen ? 0 : '-400px',
                        // }}
                        transition={Slide}
                      //   className="toast-container"
            /> */}
            <div ref={spendAnalyticsRef}>
            <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>{userData?.FirstName}, total spend for your category is <b> {formatNumberWithCommas(totalSpendValue)}{totalSpendUnit} </b>
                    {totalSpendValue &&
                        <sup><span className='spend-tooltip'>
                            <Tooltip direction="bottom-middle"
                                text={dataIssueWarningText}>
                                <Icon alt="" icon="info" size="small" />
                            </Tooltip>
                        </span>
                        </sup>
                    }
                    {
                        isEDFIntegrated &&
                        <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                            <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                        </Tooltip>
                    }
                </span>
                {
                    isLoading ? (
                        <></>
                    ) :                  
                    // !showButtonDropdown ? // Commented
                        // <ButtonGroup
                        //     style={{ marginRight: '2rem' }}
                        //     className="buy-con-button-group"
                        //     items={buttonGroupItems}
                        //     size="small"
                        // />
                        <>
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons isModal={true} appList={spendDetailViewData?.apps} />
                                
                                {/* <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}> */}
                                    {/* <DropdownWithIcons modalRef={spendAnalyticsRef} kpiName={"Spend_Analytics_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded} isSingleBarChart={true} initialSnapshot={initialSpendModalSnapshot}/> */}
                                    {/* <DropdownWithIcons modalRef={spendAnalyticsRef} kpiName={"Spend_Analytics_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded} /> */}
                                {/* </span> */}

                                {/* <button onClick={() => {
                                    setIsDownloadSingleBarChart(true);
                                    setCurrentStateRef(spendAnalyticsRef);
                                    setCurrentKPIName('Spend_Analytics_Modal')
                                    }}>
                                    PDF
                                </button> */}
                                <span style={{float: 'right', position: 'relative', bottom: '0.6rem', right: '2rem'}}>
                                    {svgDropdownIcon(true, spendAnalyticsRef, 'Spend_Analytics_Modal', false, dropdownRef, toggleDropdown, open, spendResilincDropdownoptions, setIsDownloadSingleBarChart, setIsJpegDownloaded, setCurrentStateRef, setCurrentKPIName, setOpen )}
                                </span>
                            </span>
                        </>
                        //    : // Commented
                        // <ButtonGroup
                        //     style={{ marginRight: '2rem' }}
                        //     itemCount={1}
                        //     className="buy-con-button-group-dropdown"
                        //     items={buttonGroupItems}
                        //     showMore
                        //     size="small"
                        // />
                    //    <CustomButtons isModal={true} appList={spendDetailViewData?.apps} /> // Commented
                }
            </div>
            <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {dataIssueWarningText}</div>
            {/* {
                showNote ? <div className="modal-update-frequesncy" style={{ marginBottom: "10px", display: "flex", color: 'red' }}><Icon alt="" icon="info" size="small" /> &nbsp; Note: SpendHQ number for AMESA doesn't yet include South Africa Spend (WIP) </div> : <></>
            } */}
            
            <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {"Intercompany Spends are excluded"}</div>

            {(displayDate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(refreshFrequency)}</div>}
            <ModalFilters selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getSpendDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} />
            {
                (dataLoadActionType !== "SUCCESS_SPEND_DETAIL_VIEW_ACTION" || isLoading || loader) ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                        <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                    </div>
                    :
                    <>
                        <div className="spend-detailpage-kpi-section" style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Card style={{ height: '100%',display:'flex' }}>
                                <div className='header-kpi-wrapper'>
                                {
                                    overAllSpend ? <>
                                        <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                            <div className="spend-modal-alphanumeric-value">
                                                <div className='spend-modal-numeric-value'>{formatNumberWithCommas(totalSpendValue)}</div>
                                                <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{totalSpendUnit} </div>
                                                {totalSpendValue &&
                                                    <div className='spend-tooltip'>
                                                        <Tooltip direction="right" style={{ marginLeft: "-15px" }}
                                                            text={dataIssueWarningText}>
                                                            <Icon alt="" icon="info" size="small" />
                                                        </Tooltip>
                                                    </div>
                                                }
                                            </div>
                                            <div className='spend-modal-total-spend-text'>Total Spend</div>
                                        </Col>
                                    </> : ''
                                }
                                {
                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                            {
                                                <>
                                                    <div className="spend-modal-last-year-value">
                                                        <span className="last-year">LY</span>
                                                        <span className="last-year-value">
                                                            {lastYearSpendData ? formatNumberWithCommas(lastYearSpendData) : "N/A"}
                                                        </span>
                                                    </div>
                                                </>
                                            }
                                            {
                                                percentOfLastYearData ?
                                                    <>
                                                        <div className="spend-modal-percentage-value">
                                                            <span>
                                                                {percentOfLastYearData}%
                                                            </span>
                                                            <Icon
                                                                alt="alt value"
                                                                icon={parseFloat(percentOfLastYearData) == 0 ? "" : (parseFloat(percentOfLastYearData) > 0 ? "arrow_upward" : "arrow_downward")}
                                                                size="small"
                                                                style={{ color: '#fff', fontSize: 13 }}
                                                            />
                                                        </div>
                                                    </> : ''
                                            }
                                        </div>
                                    </Col>
                                }
                                {/* { IMPORTANT TO BE ADDED LATER
                                    managedSpend ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={3} lg={4} xl={4}>
                                                <div>
                                                    <div className="spend-modal-alphanumeric-value-small">
                                                        <div className='spend-modal-numeric-value-small'>{formatNumberWithCommas(splitValueWithUnit(managedSpend)?.['numericValue'])}</div>
                                                        <div className="spend-modal-alpha-value-small">{splitValueWithUnit(managedSpend)?.['unit']}</div>
                                                    </div>
                                                    <div className='spend-modal-manage-spend'>Managed Spend</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                } */}
                                {
                                    totalSupplierCount != null ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                                <div>
                                                    <div className="spend-modal-total-supplier">{formatNumberWithCommas(totalSupplierCount)}</div>
                                                    <div className='spend-modal-manage-spend'>Total Suppliers</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                }
                                {
                                    averageSupplierSpend != null ?
                                        <>
                                            <div className="modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                                <div>
                                                    <div className="spend-modal-alphanumeric-value-small">
                                                        <div className='spend-modal-numeric-value-small'>{formatNumberWithCommas(splitValueWithUnit(averageSupplierSpend)?.['numericValue'])}</div>
                                                        <div className="spend-modal-alpha-value-small">{splitValueWithUnit(averageSupplierSpend)?.['unit']}</div>
                                                    </div>
                                                    <div className='spend-modal-manage-spend'>Avg. Supplier Spend</div>
                                                </div>
                                            </Col>
                                        </> : ''
                                }
                                {
                                    totalPoCount != null ? <>
                                        <div className="modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={3} lg={4} xl={4}>
                                            <div>
                                                <div className="spend-modal-total-supplier">{formatNumberWithCommas(totalPoCount)}</div>
                                                <div className='spend-modal-manage-spend'>Total POs</div>
                                            </div>
                                        </Col>
                                    </> : ''
                                }
                                </div>
                            </Card>
                            </Col>
                            </Row>
                        </div>
                        <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                            {/* Older Spend Charts */}
                            {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card>
                                    <Row justify={"space-between"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            {
                                                spendDetailViewData?.kpiDetailsCategoryDTOList?.length > 0 || spendDetailViewData?.kpiDetailsBuDTOList?.length > 0 ?
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "14px" }}>
                                                        <Legend title1={"Total Spend"} color1={"#0078A7"} isSingleTitle={true} />
                                                    </div>
                                                    : ''
                                            }
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                                            {
                                                spendDetailViewData?.kpiDetailsBuDTOList?.length > 0 ?
                                                    <>
                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend by Business Unit / Market {appConstants.inUSDMillion}</div>
                                                        {
                                                            showPieChart ? <PieChartWithTicks data={spendDetailViewData?.kpiDetailsBuDTOList} chartKey="buName" /> :
                                                                <StackedBarChart data={spendDetailViewData?.kpiDetailsBuDTOList} chartKey="buName" />
                                                        }
                                                    </> :
                                                    <NoData />
                                            }
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                                            {
                                                spendDetailViewData?.kpiDetailsCategoryDTOList?.length > 0 ?
                                                    <>
                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend by Category L1 {appConstants.inUSDMillion}</div>
                                                        {
                                                            showPieChart ? <PieChartWithTicks data={spendDetailViewData?.kpiDetailsCategoryDTOList} chartKey={"l1Category"} /> :
                                                                <StackedBarChart data={spendDetailViewData?.kpiDetailsCategoryDTOList} chartKey={"l1Category"} />
                                                        }
                                                    </> :
                                                    <NoData />
                                            }
                                        </Col>
                                    </Row>
                                </Card>
                            </Col> */}
                            
                            {/* New Spend Charts */}
                            {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card>
                                    <Row justify={"space-between"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                                            {
                                                transformedL0Data && transformedL0Data.length>0 ?
                                                    <>
                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend Split by Direct (D)/Indirect (I)/Co-Man (C)</div>
                                                        {
                                                            <>
                                                                <SpendDonutChart countryData={transformedL0Data} flag={multipleSectorFlagForL0Chart} isSpendChart={true} showInnerChart={l0InnerDonutFlag} />
                                                                <br/>
                                                                <LegendList legends={sectorL0Color} />
                                                            </>
                                                        }
                                                    </> :
                                                    <NoData />
                                            }
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                                            
                                            {
                                                transformedBUData && transformedBUData.length>0 ?
                                                    <>
                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend by Business Unit / Market</div>
                                                        {
                                                            <>
                                                                <SpendDonutChart countryData={transformedBUData} flag={multipleSectorFlagForBUChart} isSpendChart={true} />
                                                                <br/>
                                                                <LegendList legends={sectorBuColor} />
                                                            </>
                                                        }
                                                    </> :
                                                    <NoData />
                                            }
                                        </Col>
                                    </Row>
                                </Card>
                            </Col> */}


                            {/* <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}> */}
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <div ref={SpendSplitbyDirectRef}>
                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        {
                                                transformedL0Data && transformedL0Data.length>0 ?
                                                    <>
                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                            Spend Split by Direct (D)/Indirect (I)/Co-Man (C)
                                                            <span style={{float: 'right'}}>
                                                                <DropdownWithIcons modalRef={SpendSplitbyDirectRef} kpiName={"Spend Split by Direct (D)/Indirect (I)/Co-Man (C)"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                            </span>
                                                        </div>
                                                        {
                                                            <>
                                                                <SpendDonutChart countryData={transformedL0Data} flag={multipleSectorFlagForL0Chart} isSpendChart={true} showInnerChart={l0InnerDonutFlag} />
                                                                {/* { 
                                                                    l0ReconSpend!="1" && 
                                                                    <div className="resiliency-legend-container">
                                                                            Spend under reconciliation: 
                                                                            <span style={{color: "#aa001a"}}>{l0ReconSpend}</span>
                                                                    </div>
                                                                } */}
                                                                <br/>
                                                                <LegendList legends={sectorL0Color} />
                                                            </>
                                                        }
                                                    </> :
                                                        // l0ReconSpend!="1"?
                                                        // <>
                                                        //     <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend Split by Direct (D)/Indirect (I)/Co-Man (C)</div>
                                                        //     <NoData />
                                                        //     <div className="resiliency-legend-container">
                                                        //             Spend under reconciliation: 
                                                        //             <span style={{color: "#aa001a"}}>{l0ReconSpend}</span>
                                                        //     </div>
                                                        // </> :
                                                        <NoData />
                                        }
                                </Card>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <div ref={SpendbyBUtMarketRef}>
                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                    {
                                                transformedBUData && transformedBUData.length>0 ?
                                                    <>
                                                        <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                            Spend by Business Unit / Market
                                                            <span style={{float: 'right'}}>
                                                                <DropdownWithIcons modalRef={SpendbyBUtMarketRef} kpiName={"Spend by Business Unit / Market"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                            </span>
                                                        </div>
                                                        {
                                                            <>
                                                                <SpendDonutChart countryData={transformedBUData} flag={multipleSectorFlagForBUChart} isSpendChart={true} />
                                                                {/* { 
                                                                    buReconSpend!="1" && 
                                                                    <div className="resiliency-legend-container">
                                                                            Spend under reconciliation: 
                                                                            <span style={{color: "#aa001a"}}>{buReconSpend}</span>
                                                                    </div>
                                                                } */}
                                                                <br/>
                                                                <LegendList legends={sectorBuColor} />
                                                            </>
                                                        }
                                                    </>:
                                                        // buReconSpend!="1"?
                                                        //     <>
                                                        //         <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend by Business Unit / Market</div>
                                                        //         <NoData />
                                                        //         <div className="resiliency-legend-container">
                                                        //                 Spend under reconciliation: 
                                                        //                 <span style={{color: "#aa001a"}}>{buReconSpend}</span>
                                                        //         </div>
                                                        //     </>:
                                                            <NoData />
                                    }
                                </Card>
                                </div>
                            </Col>
                            <br />

                            {/* </Row> */}

                            {/* 
                            Stacked Bar Charts instead of Donut Chart
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%' }}>
                                    {
                                        categoryL0StackData && categoryL0StackData.length>0 ?
                                            <>
                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend Split by Direct (D)/Indirect (I)/Co-Man (C) {appConstants.inUSDMillion}</div>          
                                                <SpendStackedBarChart categories={categoryL0Color} data={categoryL0StackData}/>
                                                //  <LegendList legends={sectorL0Color} /> 
                                           </> 
                                           :
                                             <NoData />
                                    }
                                </Card>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%' }}>
                                    {
                                        categoryBUStackData && categoryBUStackData.length>0 ?
                                            <>
                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>Spend by Business Unit / Market {appConstants.inUSDMillion}</div>          
                                                <SpendStackedBarChart categories={categoryBUColor} data={categoryBUStackData}/>
                                                // <LegendList legends={sectorBuColor} />
                                           </> 
                                           :
                                             <NoData />
                                    }
                                </Card>
                            </Col> */}



                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div ref={SpendbySubCategoryRef}>
                                    <Card style={{ height: '100%' }}>
                                        {
                                            categoryStackData && categoryStackData.length>0 ?
                                                <>
                                                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                        Spend by SubCategory (L1) {appConstants.inUSDMillion}
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons modalRef={SpendbySubCategoryRef} kpiName={"Spend by SubCategory (L1) (in USD Million)"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                        </span>
                                                    </div>                
                                                    <SpendStackedBarChart categories={categoryColor} data={categoryStackData} isSpendCategoryChart={true}/>
                                                    <LegendList legends={sectorCategoryColor} />
                                            </> 
                                            :
                                                <NoData />
                                        }
                                    </Card>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <div ref={SpendbyTop10SuppliersRef}>
                                    <Card style={{ height: '100%' }} ellipsis={false} icon={""}>
                                        {
                                            spendByTopSupplier?.length > 0 ?
                                                <>
                                                    <h3 style={{ textAlign: 'left', width: '100%', color: '#3A3A3A' }}>
                                                        Spend by Top 10 Suppliers {appConstants.inUSDMillion}
                                                        {/* <span style={{float: 'right'}}>
                                                            <DropdownWithIcons modalRef={SpendbyTop10SuppliersRef} kpiName={"Spend by Top 10 Suppliers (in USD Million)"} checkPDFDownloaded={checkPDFDownloaded} />
                                                        </span> */}
                                                        {/* <button
                                                                onClick={() => {
                                                                    setIsDownloadSingleBarChart(true);
                                                                    setCurrentStateRef(SpendbyTop10SuppliersRef);
                                                                    setCurrentKPIName('Spend by Top 10 Suppliers (in USD Million)')
                                                                }}
                                                        >
                                                            PDF
                                                        </button> */}
                                                        <span style={{float: 'right'}}>
                                                            {/* {svgDropdownIconSpendTop10(false, SpendbyTop10SuppliersRef, 'Spend by Top 10 Suppliers (in USD Million)', false )} */}
                                                            {svgDropdownIconSingleBarChart(false, SpendbyTop10SuppliersRef, 'Spend by Top 10 Suppliers (in USD Million)', false )}
                                                        </span>
                                                    </h3>
                                                    <Row style={{ width: '100%', height: 75 }}>
                                                        <Col span={24}>
                                                            <div className="spend-stats-text">Total Spend</div>
                                                        </Col>
                                                        {/* <Col span={6}> IMPORTANT TO BE ADDED LATER
                                                            <div className='spend-analytics-singlechart-stats-right'> Proportion of Managed Spend</div>
                                                        </Col> */}
                                                        <Col span={24}>
                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(spendDetailViewData?.topTenSupplierDTO?.totalSpend)['numericValue'])}</div>
                                                                <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(spendDetailViewData?.topTenSupplierDTO?.totalSpend)['unit']}</div>
                                                            </div>
                                                        </Col>
                                                        {/* <Col span={12}> IMPORTANT TO BE ADDED LATER
                                                            <div className='spend-analytics-singlechart-stats-value-right' style={{ fontSize: '25px' }}>{spendDetailViewData &&
                                                                (spendDetailViewData?.topTenSupplierDTO?.proportionOfManangedSpend ?
                                                                    `${formatNumberWithCommas(spendDetailViewData?.topTenSupplierDTO?.proportionOfManangedSpend)
                                                                    }%`
                                                                    : "-"
                                                                )}</div>
                                                        </Col> */}
                                                    </Row>
                                                    <SingleBarChart data={isDownloadSingleBarChart ? spendByTopSupplier.slice(0,10) : spendByTopSupplier} />
                                                </> :
                                                <NoData />
                                        }
                                    </Card>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <div ref={TailSpendRef}>
                                    <Card style={{ height: '100%' }}  ellipsis={false} icon={""}>
                                        {
                                            totalBottomSuppliers?.length > 0 ?
                                                <>
                                                    <h3 style={{ textAlign: 'left', width: '100%', color: '#3A3A3A' }}>
                                                        Tail Spend - Suppliers with Bottom 20% of Spending {appConstants.inUSDMillion}
                                                        {/* <span style={{float: 'right'}}>
                                                            <DropdownWithIcons modalRef={TailSpendRef} kpiName={"Tail Spend - Suppliers with Bottom 20% of Spending (in USD Million)"} checkPDFDownloaded={checkPDFDownloaded} />
                                                        </span> */}

                                                        {/* <button
                                                                onClick={() => {
                                                                    setIsDownloadSingleBarChart(true);
                                                                    setCurrentStateRef(TailSpendRef);
                                                                    setCurrentKPIName('Tail Spend - Suppliers with Bottom 20% of Spending (in USD Million)')
                                                                }}
                                                        >
                                                            PDF
                                                        </button> */}
                                                        <span style={{float: 'right'}}>
                                                            {svgDropdownIconSingleBarChart(false, TailSpendRef, 'Tail Spend - Suppliers with Bottom 20% of Spending (in USD Million)', false )}
                                                        </span>
                                                    </h3>
                                                    <Row style={{ width: '100%', height: 75 }}>
                                                        <Col span={12}><div className="spend-stats-text">Total Spend</div></Col>
                                                        <Col span={12}><div className="spend-stats-text">Total Suppliers</div></Col>
                                                        {/* <Col span={8}><div className="spend-stats-text">Total POs</div></Col> */}
                                                        {/*  IMPORTANT TO BE ADDED LATER <Col span={6}><div className="spend-stats-text">Proportion of Managed Spend</div></Col> */}
                                                        <Col span={12}>
                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(spendDetailViewData?.kpiDetailsForSpendDataForTailSpend?.totalSpend)['numericValue'])}</div>
                                                                <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(spendDetailViewData?.kpiDetailsForSpendDataForTailSpend?.totalSpend)['unit']}</div>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}><div className="spend-stats-value" style={{ fontSize: '25px' }}>{spendDetailViewData && formatNumberWithCommas(spendDetailViewData?.kpiDetailsForSpendDataForTailSpend?.totalSupplierForTailSpend)}</div></div>
                                                        </Col>
                                                        {/* <Col span={8}>
                                                            <div className='spend-analytics-singlechart-stats-value-right'>{spendDetailViewData && formatNumberWithCommas(spendDetailViewData?.kpiDetailsForSpendDataForTailSpend?.totalPOsForTailSpend)}</div>
                                                        </Col> */}
                                                        {/* <Col span={6}>  IMPORTANT TO BE ADDED LATER
                                                            <div className='spend-analytics-singlechart-stats-value-right'>{spendDetailViewData &&
                                                                (spendDetailViewData?.kpiDetailsForSpendDataForTailSpend?.proportionToManagedSpend ?
                                                                    `${formatNumberWithCommas(spendDetailViewData?.kpiDetailsForSpendDataForTailSpend?.proportionToManagedSpend)
                                                                    }%`
                                                                    : "-"
                                                                )}</div>
                                                        </Col> */}
                                                    </Row>
                                                    <SingleBarChart data={isDownloadSingleBarChart ? totalBottomSuppliers.slice(0,10) : totalBottomSuppliers} />
                                                </> :
                                                <NoData />
                                        }
                                    </Card>
                                </div>
                            </Col>

                            
                            {
                            negativeL0StackData && negativeL0StackData.length>0 &&
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div ref={SpendUnderReconciliationRef}>
                                <Card style={{ height: '100%' }}>
                                            <>
                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left", display: "flex", justifyContent:"space-between" }}>
                                                    <span>Spend Under Reconciliation {appConstants.inUSDMillion}</span>
                                                    <span style={{display:"flex"}}>
                                                        <span style={{position: 'relative', right: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                            <span className='ph-spend-toggle-text' style={{fontWeight:!negativeSpendGraphTab?"700":"400"}}>In Categories</span>
                                                            <Toggle
                                                                    label=""
                                                                    onUpdate={function Ma(e) {
                                                                        setNegativeSpendGraphTab(e)
                                                                    }}
                                                                    size="small"
                                                                    value={negativeSpendGraphTab}
                                                                    variant="horizontal"
                                                                />
                                                            <span className='ph-spend-toggle-text' style={{fontWeight:negativeSpendGraphTab?"700":"400"}}> &nbsp;&nbsp;In BU</span>    
                                                        </span>            
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons modalRef={SpendUnderReconciliationRef} kpiName={"Spend Under Reconciliation (in USD Million)"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                        </span>
                                                    </span>
                                                    
                                                </div>
                                                {
                                                    !negativeSpendGraphTab?
                                                        <>
                                                            <SpendStackedBarChart categories={negativeL0Color} data={negativeL0StackData} chartOrientation="negative"/>
                                                            <LegendList legends={sectorNegativeCategoryColor} />
                                                            
                                                        </>
                                                    : 
                                                        <>
                                                            <SpendStackedBarChart categories={negativeBUColor} data={negativeBUStackData} chartOrientation="negative"/>
                                                            <LegendList legends={sectorNegativeBuColor} />
                                                        </>    
                                                }
                                                
                                           </> 
                                </Card>
                                </div>
                            </Col>
                            }
                        </Row>
                        <br />

                        <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                            <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                                <React.Fragment key={index}>
                                    <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                    {index < appOwnersList.length - 1 && ', '}
                                </React.Fragment>
                            ))} for any query on the data displayed.</div>
                            <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                        </div>

                        {
                                showInprogressModal ? (
                                    <>
                                        <Modal
                                          
                                            closeOnOutsideClick={false}
                                            hideCloseButton
                                            //   onCloseModal={function oFe(){setInactiveModal(false)}}
                                            //   primaryButtonProps={{
                                            //     onClick: handleContinue,
                                            //     size: 'medium',
                                            //     text: 'Continue',
                                            //     variant: 'primary'
                                            //   }}
                                            //   secondaryButtonProps={{
                                            //     onClick: handleExitEditorMode,
                                            //     size: 'medium',
                                            //     text: 'Exit',
                                            //     variant: 'tertiary'
                                            //   }}
                                            showModal={true}
                                            showPrimaryButton={false}
                                              showLink={false}
                                                showSecondaryButton={false}
                                                showTertiaryButton={false}
                                                showAuxiliaryButton={false}
                                            type="S"
                                            >
                                                <div>
                                                    <div className="download-inprogress-text">Downloading In Progress... </div>
                                                </div>
                                            </Modal>
                                        
                                    </>
                                ) : <></>
                            }

                    </>
            }
            <br/>
            </div>
        </Modal>
    )
}

export default KpiModal